// @flow
import isEmpty from 'lodash/fp/isEmpty';

export default function withoutAppBanner(config: Object) {
  const newConfig = Object.assign({}, config);
  const appBannerName = 'apple-itunes-app';

  newConfig.app.head.meta = config.app.head.meta
    .map(val => {
      if (val.name && val.name === appBannerName) {
        return null;
      }

      return val;
    })
    .filter(val => !isEmpty(val));

  return newConfig;
}
